module.exports = __webpack_public_path__ + "media/images/about/arrow-2d25174d1f496f8792daca54e468a286.png";